<template>
  <div>
    <top :id="'seckill'"></top>
    <banner :url="url"></banner>
    <div class="container">
      <breadcrumb :url="url"></breadcrumb>
      <tit :title="'产品秒杀'"></tit>
      <div class="F-flex">
        <div class="seckill1" v-for="item in seckilLIst1" :key="item.id">
          <img :src="item.image" alt="" />
          <div class="seckill-box" style="top: 40px">
            <div class="f24">{{ item.title }}</div>
            <div class="F-flex seckill-money" style="margin-top: 30px">
              <div>
                <div class="f28 orange">¥{{ item.price }}</div>
                <div class="f14 text-decoration grey">
                  ¥{{ item.original_price }}
                </div>
              </div>
              <div
                class="btn btn-pos"
                style="right: -40px; bottom: auto"
                @click="shoppingBnt(item.id)"
              >
                立即购买
              </div>
            </div>
          </div>
        </div>
        <div
          class="seckill2"
          v-for="item in seckilLIst2"
          :key="item.id"
          style="width: 483px; margin-left: 18px"
        >
          <img :src="item.image" alt="" />
          <div class="seckill-box" style="top: 40px">
            <div class="f24">{{ item.title }}</div>
            <div class="seckill-money" style="margin-top: 30px">
              <div class="F-flex">
                <div class="f28 orange">¥{{ item.price }}</div>
                <div class="f14 text-decoration grey">
                  ¥{{ item.original_price }}
                </div>
              </div>
              <div class="btn btn-pos" @click="shoppingBnt(item.id)">
                立即购买
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="seckil_wp_l">
        <div class="F-flex" v-for="item in seckilLIst3" :key="item.id">
          <div class="seckill2" style="margin-right: 26px">
            <img :src="item.image" alt="" />
            <div class="seckill-box" style="top: 40px">
              <div class="f24">{{ item.title }}</div>
              <div class="seckill-money" style="margin-top: 30px">
                <div class="F-flex">
                  <div class="f28 orange">¥{{ item.price }}</div>
                  <div class="f14 text-decoration grey">
                    ¥{{ item.original_price }}
                  </div>
                </div>
                <div class="btn btn-pos" @click="shoppingBnt(item.id)">
                  立即购买
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="flex flex-wrap">
				<div class="seckill3" v-for="item in seckilLIst4" :key="item.id">
					<img :src="item.image" alt="">
					<div class="seckill-con">
						<div class="f24" style="margin-bottom: 20px;">{{item.title}}</div>
						<div class="F-flex" >
							<div >
								<div class="f20 orange">¥{{ item.price }}</div>
								<div class="f12 grey text-decoration">¥{{ item.original_price }}</div>
							</div>
							<div class="btn"  @click="shoppingBnt(item.id)">立即购买</div>
						</div>
					</div>
				</div>
			</div> -->
      <div class="goods-box flex flex-wrap">
        <div class="goods-item" v-for="item in seckilLIst4" :key="item.id">
          <img :src="item.image" alt="" class="goods-img" />
          <div class="goods-name flex ali-cen">
            <div class="goods-tag">修复</div>
            <div class="goods-name-text">{{ item.title }}</div>
          </div>
          <div class="goods-price F-flex">
            <div style="color: #ff6701; font-size: 14px">¥{{ item.price }}</div>
            <div class="goods-btn" @click="specialBuy(item.id)">立即购买</div>
          </div>
        </div>
      </div>
          <div class="" style="" v-for="(item,index) in specialListall" :key="index">
                  <div style="margin-bottom:15px;color: #606266">
                     {{item.title}}
                  </div>
                  <div style="display:flex; flex-wrap: wrap;">
                       <div class="goods-item" style="margin-right: 9px;" v-for="item in item.goodsList.data" :key="item.id">
                     
                        <img
                            :src="item.image"
                            alt=""
                            class="goods-img"
                        />
                        <div class="goods-name flex ali-cen">
                            <div class="goods-tag">修复</div>
                            <div class="goods-name-text">
                                {{item.title}}
                            </div>
                        </div>
                        <div class="goods-text">
                           {{item.subtitle}}
                        </div>
                        <div class="goods-price F-flex">
                            <div style="color: #FF6701;font-size: 14px;">
                                ¥{{item.price}}
                            </div>
                            <div class="goods-btn" @click="shoppingBnt(item.id)">立即购买</div>
                        </div>
                    </div>
                  </div>
                
        </div>
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import top from "../../components/top.vue";
import breadcrumb from "../../components/breadcrumb.vue";
import bottom from "../../components/bottom.vue";
import banner from "../../components/banner.vue";
import tit from "../../components/title.vue";
import goods from "../../components/goods.vue";
import { newProduct } from "@/api/index.js";
if (localStorage.getItem("userInfo")) {
  var token = JSON.parse(localStorage.getItem("userInfo")).token;
  var header = {
    "Content-Type": "application/json",
    token: token,
    platform: "H5",
  };
}
export default {
  data() {
    return {
      url: [{ name: "全网低价", url: "/seckill" }],
      seckilLIst1: [],
      seckilLIst2: [],
      seckilLIst3: [],
      seckilLIst4: [],
      specialListall:[]
    };
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#f5f5f5");
  },
  created() {
    this.soLOwPrice();
  },
  methods: {
    //全网低价
    soLOwPrice() {
      newProduct({ activity: "seckill", type: "ing" }, header).then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          this.seckilLIst1 = res.data[0].goodsList.data.slice(0, 1);
          this.seckilLIst2 = res.data[0].goodsList.data.slice(1, 2);
          this.seckilLIst3 = res.data[0].goodsList.data.slice(2, 5);
          this.seckilLIst4 = res.data[0].goodsList.data.slice(5);
          this.specialListall = res.data.slice(1)
        }
      });
    },
    //点击立即购买
    shoppingBnt(id) {
      this.$router.push({ name: "info", query: { id: id } });
    },
  },
  components: {
    top,
    breadcrumb,
    bottom,
    banner,
    tit,
    goods,
  },
};
</script>
<style scoped lang="less">
.goods-item {
  width: 231px;
//   height: 301px;
  background: #ffffff;
  border: 1px solid #d2d2d2;
  padding: 10px;
  margin-bottom: 14px;
  .goods-img {
    width: 207px;
    height: 200px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .goods-name {
    font-size: 16px;
    margin-bottom: 20px;
    .goods-tag {
      width: 43px;
      height: 15px;
      background: #5db031;
      border-radius: 10px;
      text-align: center;
      font-size: 10px;
      line-height: 15px;
      color: #fff;
    }
    .goods-name-text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 166px;
    }
  }
  .goods-text {
    font-size: 12px;
    margin: 5px 0;
  }
  .goods-btn {
    width: 70px;
    height: 22px;
    background: #ff6701;
    text-align: center;
    line-height: 22px;
    color: #fff;
    font-size: 12px;
    border-radius: 11px;
    cursor: pointer;
  }
}
.seckil_wp_l {
  display: flex;
}
.seckill1 {
  width: 704px;
  height: 312px;
  position: relative;
  margin-bottom: 20px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
}
.seckill2 {
  cursor: pointer;
  width: 383px;
  height: 312px;
  position: relative;
  margin-bottom: 20px;
  // margin-right: 26px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
}
.seckill3 {
  cursor: pointer;
  width: 383px;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  margin-right: 25px;
  &:nth-child(3n + 3) {
    margin-right: 0;
  }
  img {
    width: 383px;
    height: 223px;
    border-radius: 8px 8px 0 0;
  }
  .seckill-con {
    padding: 30px;
  }
}
.btn {
  width: 111px;
  height: 34px;
  background: #ff6701;
  border-radius: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}
.btn-pos {
  position: absolute;
  bottom: -60px;
  right: 50px;
}
.seckill-box {
  padding: 30px 20px;
  width: 242px;
  height: 191px;
  background: #ffffff;
  border-radius: 8px;
  opacity: 0.84;
  position: absolute;
  top: 10px;
  right: 30px;
  z-index: 10;
  .seckill-money {
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/seckill.vue